import Vue from 'vue';

Vue.component('hourly-index', () =>
    import(/* webpackChunkName: 'hourly' */ './hourly-index.vue'),
);

Vue.component('vuetable_hourly', () =>
    import(/* webpackChunkName: 'hourly' */ './vuetable_hourly.vue'),
);

Vue.component('vue_hourly', () =>
    import(/* webpackChunkName: 'hourly' */ './vue_hourly.vue'),
);
